import { Heading } from "@app/_components/ui";
import RichText from "@blocks/RichText";
import type { TextBlockFragment } from "@server/gql/graphql";

type TextBlockProps = TextBlockFragment & {
  market: string;
  locale?: string;
  className?: string;
};

export default function TextBlock(props: TextBlockProps) {
  const { title, market, locale, content, className } = props;

  return (
    <div className={className}>
      <Heading size={4} as="h2" className="leading-tight">
        {title}
      </Heading>
      {content?.json && (
        <RichText content={content} locale={locale} market={market} />
      )}
    </div>
  );
}
